import { getPositions } from '../../utils/getPositionsUtils';
import { ConfigRulesProps } from './config.types';

export const englishConfig = [
  'I', 'T', 'L', 'I', 'S', 'A', 'S', 'A', 'M', 'P', 'M',
  'A', 'C', 'Q', 'U', 'A', 'R', 'T', 'E', 'R', 'D', 'F',
  'T', 'W', 'E', 'N', 'T', 'Y', 'X', 'F', 'I', 'V', 'E',
  'H', 'A', 'L', 'F', 'B', 'T', 'E', 'N', 'F', 'T', 'O',
  'P', 'A', 'S', 'T', 'E', 'R', 'U', 'N', 'I', 'N', 'E',
  'O', 'N', 'E', 'S', 'I', 'X', 'T', 'H', 'R', 'E', 'E',
  'F', 'O', 'U', 'R', 'F', 'I', 'V', 'E', 'T', 'W', 'O',
  'E', 'I', 'G', 'H', 'T', 'E', 'L', 'E', 'V', 'E', 'N',
  'S', 'E', 'V', 'E', 'N', 'T', 'W', 'E', 'L', 'V', 'E',
  'T', 'E', 'N', 'S', 'Y', 'Ó', 'C', 'L', 'O', 'C', 'K',
];

export const englishConfigRules: ConfigRulesProps = {
  start: getPositions(['it', 'is'], englishConfig),
  end: getPositions(['óclock'], englishConfig),
  one: getPositions(['one'], englishConfig),
  two: getPositions(['two'], englishConfig),
  three: getPositions(['three'], englishConfig),
  four: getPositions(['four'], englishConfig),
  five: getPositions(['five'], englishConfig),
  six: getPositions(['six'], englishConfig),
  seven: getPositions(['seven'], englishConfig),
  eight: getPositions(['eight'], englishConfig),
  nine: getPositions(['nine'], englishConfig),
  ten: getPositions(['ten'], englishConfig),
  eleven: getPositions(['eleven'], englishConfig),
  twelve: getPositions(['twelve'], englishConfig),
  fiveAfter: getPositions(['five', 'past'], englishConfig, { preferFirst: true }),
  tenAfter: getPositions(['ten', 'past'], englishConfig, { preferFirst: true }),
  quarterAfter: getPositions(['quarter', 'past'], englishConfig),
  twentyAfter: getPositions(['twenty', 'past'], englishConfig),
  fiveBeforeHalf: getPositions(['twenty', 'five', 'past'], englishConfig, { preferFirst: true }), // 25 past = 5 before half
  half: getPositions(['half', 'past'], englishConfig),
  fiveAfterHalf: getPositions(['twenty', 'five', 'to'], englishConfig, { preferFirst: true }), // 25 to = 5 after half
  fiveBefore: getPositions(['five', 'to'], englishConfig, { preferFirst: true }),
  tenBefore: getPositions(['ten', 'to'], englishConfig, { preferFirst: true }),
  quarterBefore: getPositions(['quarter', 'to'], englishConfig),
  twentyBefore: getPositions(['twenty', 'to'], englishConfig),
};
